export default __webpack_public_path__ + "static/empowering-edtech-platform-SIS-solution-980b0e8040fc39186eaef7999cc5a966.jpg";